import { getShowNextDate } from "./ModalSignup.helpers";

/**
 * Action types
 * @property {string} MODAL_SIGNUP_ACCEPT
 * @property {string} MODAL_SIGNUP_REJECT
 * @property {string} MODAL_SIGNUP_OPEN
 * @property {string} SIGNUP_FOOTER_SUBMIT
 * @property {string} SIGNUP_PAGE_COMPLETE
 */
export const types = {
  MODAL_SIGNUP_ACCEPT: "MODAL_SIGNUP_ACCEPT",
  MODAL_SIGNUP_REJECT: "MODAL_SIGNUP_REJECT",
  MODAL_SIGNUP_OPEN: "MODAL_SIGNUP_OPEN",
  SIGNUP_FOOTER_SUBMIT: "SIGNUP_FOOTER_SUBMIT",
  SIGNUP_PAGE_COMPLETE: "SIGNUP_PAGE_COMPLETE",
};

/**
 * @namespace Reducers
 */
export const reducers = {
  /**
   * Updates the modal signup open state
   * @param {string} state
   * @param {object} action
   * @param {string} action.type
   * @memberof Reducers
   */
  modalSignupOpen: (state = false, action) => {
    switch (action.type) {
      case types.MODAL_SIGNUP_ACCEPT:
      case types.MODAL_SIGNUP_REJECT:
        return false;
      case types.MODAL_SIGNUP_OPEN:
        return true;
      default:
        return state;
    }
  },
  /**
   * Updates the modal signup show next state
   * @param {string} state
   * @param {object} action
   * @param {string} action.type
   * @memberof Reducers
   */
  modalSignupShowNext: (state = null, action) => {
    switch (action.type) {
      case types.MODAL_SIGNUP_ACCEPT:
      case types.MODAL_SIGNUP_REJECT:
        return getShowNextDate();
      case types.SIGNUP_PAGE_COMPLETE:
        return getShowNextDate(true);
      default:
        return state;
    }
  },
  /**
   * Updates the modal signup email state
   * @param {string} state
   * @param {object} action
   * @param {string} action.type
   * @param {string} action.email
   * @memberof Reducers
   */
  signupEmail: (state = "", action) => {
    switch (action.type) {
      case types.MODAL_SIGNUP_ACCEPT:
      case types.SIGNUP_FOOTER_SUBMIT:
        return action.email;
      case types.MODAL_SIGNUP_REJECT:
      case types.SIGNUP_PAGE_COMPLETE:
        return "";
      default:
        return state;
    }
  },
  /**
   * Updates the signup footer show next state
   * @param {string} state
   * @param {object} action
   * @param {string} action.type
   * @memberof Reducers
   */
  signupFooterShowNext: (state = null, action) => {
    switch (action.type) {
      case types.SIGNUP_PAGE_COMPLETE:
        return getShowNextDate(true);
      default:
        return state;
    }
  },
};

/**
 * @namespace Actions
 */
export const actions = {
  /**
   * Close signup modal
   * @param {boolean} accepted - Whether the user accepted the signup
   * @param {string} email - The email address of the user
   * @memberof Actions
   */
  handleClose: (accepted = false, email = "") => {
    if (accepted) {
      return {
        type: types.MODAL_SIGNUP_ACCEPT,
        email,
      };
    }
    return {
      type: types.MODAL_SIGNUP_REJECT,
    };
  },

  /**
   * Open signup modal
   * @memberof Actions
   */
  handleOpen: () => ({
    type: types.MODAL_SIGNUP_OPEN,
  }),

  /**
   * Complete signup modal
   * @memberof Actions
   */
  handleComplete: () => ({
    type: types.SIGNUP_PAGE_COMPLETE,
  }),

  /**
   * Handle signup footer submit
   * @param {string} email - The email address of the user
   * @memberof Actions
   */
  handleSignupFooterSubmit: email => ({
    type: types.SIGNUP_FOOTER_SUBMIT,
    email,
  }),
};
